<template>
  <div>
    <div class="mb-8">
      <div class="font-size-14 ga-2 d-flex align-center mb-4">
        <span class="font-weight-bold">Зв'язки з документами</span>
        <span class="text-disabled">({{ documentLinks.length }})</span>
      </div>

      <v-card>
        <v-card-text>
          <v-data-table
            :headers="contractorDocumentLinksHeaders"
            :hide-default-footer="true"
            :items="documentLinks"
            :items-per-page="-1">
            <template #item.name="{ item }">
              {{ item.name || item.definition?.name || '—' }}
            </template>

            <template #item.status="{ item }">
              {{
                item.status?.name || keyToLabel(item.status, 'documentStatus')
              }}
            </template>

            <template #item.actions="{ item }">
              <div class="d-flex justify-center ga-2">
                <v-btn variant="outlined" :to="item._route">Перейти</v-btn>
              </div>
            </template>

            <template #no-data>
              <empty-section title="Зв'язки з документами відсутні" />
            </template>

            <template #bottom></template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>

    <div>
      <div class="font-size-14 ga-2 d-flex align-center mb-4">
        <span class="font-weight-bold">Зв'язки із завданнями</span>
        <span class="text-disabled">({{ taskLinks.length }})</span>
      </div>

      <v-card>
        <v-card-text>
          <v-data-table
            :headers="contractorTaskLinksHeaders"
            :hide-default-footer="true"
            :items="taskLinks"
            :items-per-page="-1">
            <template #item.deadline="{ item }">
              {{
                item.deadline ? new CustomDate(item.deadline).toString() : '—'
              }}
            </template>

            <template #item.status="{ item }">
              {{ item.status?.name || item.status || '' }}
            </template>

            <template #item.actions="{ item }">
              <div class="d-flex justify-center ga-2">
                <v-btn variant="outlined" :to="item._route">Перейти</v-btn>
              </div>
            </template>

            <template #no-data>
              <empty-section title="Зв'язки із завданнями відсутні" />
            </template>

            <template #bottom></template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import { CustomDate } from 'best-modules/utils'
import EmptySection from '@/components/EmptySection.vue'
import { useContractorStore } from '@/pages/contractor/single/contractor'
import {
  contractorDocumentLinksHeaders,
  contractorTaskLinksHeaders,
} from '@/pages/contractor/single/headers'
import { keyToLabel } from '@/utils/key-to-label'

export default {
  name: 'ContractorLinksTab',
  components: { EmptySection },
  setup() {
    return {
      ...useContractorStore(),
      contractorDocumentLinksHeaders,
      contractorTaskLinksHeaders,
      CustomDate,
      keyToLabel,
    }
  },
}
</script>
